import React, { Component } from "react";
import { connect } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  PagingOptions,
  NoDataIndication,
  DelBtn,
  downloadFile,
  CORE_MODULE,
  VEHICLE_CUSTOMER_NOTE_ENTITY,
  DELETE_PERMISSION,
  NO_DATA,
} from "../../utils";
import { fetchGeneralVehicleNote } from "../../store/actions/vehicle";
import { showDeleteDialog } from "../../store/actions/dialog";
import moment from "moment";
import { Link } from "react-router-dom";
import { HasAccess } from "../../components/Access";
import ColumnText from "../../components/Column";

class VehicleGeneralNoteScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sort: [
        {
          dataField: "id",
          order: "desc",
        },
      ],
    };
    this.handleTableChange = this.handleTableChange.bind(this);
    this.addHandler = this.addHandler.bind(this);
    this.editHandler = this.editHandler.bind(this);
    this.deleteHandler = this.deleteHandler.bind(this);
    this.downloadInvoice = this.downloadInvoice.bind(this);
  }
  renderColumns() {
    return [{
      dataField: "modification_time",
      text: (
        <ColumnText
          Module={CORE_MODULE}
          Entity={VEHICLE_CUSTOMER_NOTE_ENTITY}
          Label={"modification_time"}
        />
      ),
      sort: true,
      headerClasses: "cell-header cell-vnote-modification_time-header",
      classes: "cell-vnote-created",
      formatter: (cellContent, row) => {
        if (cellContent !== "" && cellContent !== null && typeof cellContent !== "undefined") {
          return <>{moment(cellContent).format("DD.MM.YYYY")}</>;
        }
      },
    },
      {
        dataField: "vehicle.vin",
        text: (
          <ColumnText
            Module={CORE_MODULE}
            Entity={VEHICLE_CUSTOMER_NOTE_ENTITY}
            Label={"vehicle"}
          />
        ),
        sort: true,
        headerClasses: "cell-header cell-vgnote-vin-header",
        classes: "cell-vgnote-vin",
        formatter: (cellContent, row) => {
          return (
            <>
              <Link
                to={"#"}
                onClick={() => {
                  this.vehicleDetailHandler(row);
                }}
              >
                {cellContent}
              </Link>
            </>
          );
        },
      },
      {
        dataField: "content",
        text: (
          <ColumnText
            Module={CORE_MODULE}
            Entity={VEHICLE_CUSTOMER_NOTE_ENTITY}
            Label={"content"}
          />
        ),
        sort: true,
        headerClasses: "cell-header cell-vgnote-content-header",
        classes: "cell-vgnote-content",
      },

      {
        dataField: "attachment",
        text: (
          <ColumnText
            Module={CORE_MODULE}
            Entity={VEHICLE_CUSTOMER_NOTE_ENTITY}
            Label={"attachment"}
          />
        ),
        sort: true,
        headerClasses: "cell-header cell-vgnote-attachment-header",
        classes: "cell-vgnote-attachment",
        formatter: (cellContent, row) => {
          let cell = cellContent !== null && typeof cellContent !== "undefined" ? JSON.parse(cellContent) : {};
          //let url = (cell !== {})?cell.path:'';
          let mime_type = cell !== {} ? cell.mime_type : "";
          let name = cell !== {} ? cell.original_name : "";

          let url =
            "data/core/vehicle_note/" + row.id + "/download/attachment";
          if (url !== "") {
            return (
              <>
                {" "}
                <Link
                  to="#"
                  onClick={() => this.downloadInvoice(url, mime_type, name)}
                >
                  {name}
                </Link>
              </>
            );
          }
        },
      },

      {
        dataField: "id",
        text: "",
        sort: false,
        headerClasses:
          "cell-actions cell-actions-header cell-vgnote-actions-header",
        classes: "cell-actions cell-vgnote-actions",
        formatter: (cellContent, row) => {
          return (
            <div className="svg">
              <HasAccess
                Module={CORE_MODULE}
                Entity={VEHICLE_CUSTOMER_NOTE_ENTITY}
                Label={DELETE_PERMISSION}
              >
                <Link
                  to={"#"}
                  onClick={() => {
                    this.deleteHandler(row);
                  }}
                >
                  <DelBtn />
                </Link>
              </HasAccess>
            </div>
          );
        },
      },
    ];
  }

  componentDidMount() {
    
  }

  handleTableChange(
    type,
    { filters, page, sortField, sortOrder, sizePerPage }
  ) {
    let defaultOrder = this.state.sort;
    let sortOrderstring =
      typeof sortOrder !== "undefined"
        ? "-" + sortOrder
        : "-" + defaultOrder[0]["order"];
    let sort_field =
      defaultOrder[0]["dataField"].indexOf(".") === -1
        ? "me." + defaultOrder[0]["dataField"]
        : defaultOrder[0]["dataField"];
    if (sortField !== null) {
      sort_field =
        sortField.indexOf(".") === -1 ? "me." + sortField : sortField;
    }
    let data = {}; 
    data.attrs = {};
    data.attrs["prefetch"] = ["vehicle"];
    data.attrs["order_by"] = {};
    data.attrs.order_by[sortOrderstring] = sort_field;

    data.conds = {};  
    if(this.props.vehicleId !== null) {
      data.conds["vehicle.id"] = this.props.vehicleId;
    }
    data.page = page;
    data.page_size = sizePerPage;

    this.props.dispatch(fetchGeneralVehicleNote(data));
  }

  downloadInvoice(url, mimeType, filename) {
    downloadFile(url, filename, mimeType);
  }

  addHandler() {
    let url =
      "/admin/vehicles/" + this.props.match.params.vid + "/vehicle-notes/add/general";
    this.props.historyRef.push(url);
  }

  vehicleDetailHandler(row) {
    if (typeof row.vehicle.id !== "undefined") {
      let url = "/admin/vehicles/view/" + row.vehicle.id;
      this.props.historyRef.push(url);
    }
  }

  editHandler(row) {
    let url =
      "/admin/vehicles/" +
      row.vehicle.id +
      "/vehicle-notes-general/" +
      row.id +
      "/edit";
    this.props.historyRef.push(url);
  }

  deleteHandler(row) {
    let rowId = row.id;
    let successor = row !== null ? row.successor : null;
    let rowData = { post: { successor: null } };
    if (rowId !== null) {
      rowData["id"] = rowId;
    }
    if (successor !== null) {
      rowData["post"]["successor"] = successor;
    }
    rowData["url"] =
      "/data/core/vehicle_customer_note/" + rowId + "/transitions/delete";
    rowData["redirect_to"] =
      "/admin/vehicles/" + row.vehicle.id + "/vehicle-notes";
    if (row !== null && typeof rowId !== "undefined") {
      this.props.dispatch(showDeleteDialog(rowData));
    }
  }

  render() {
    let options = PagingOptions;
    options.totalSize =
      typeof this.props.generalData !== "undefined" &&
      typeof this.props.generalData.rows !== "undefined" &&
      typeof this.props.generalData.rows.meta.filtered !== "undefined"
        ? this.props.generalData.rows.meta.filtered
        : "";
    options.sizePerPage =
      typeof this.props.generalData !== "undefined" &&
      typeof this.props.generalData.rows !== "undefined" &&
      typeof this.props.generalData.rows.meta.page_size !== "undefined"
        ? this.props.generalData.rows.meta.page_size
        : 10;
    let vehicle_data =
      typeof this.props.generalData !== "undefined" &&
      typeof this.props.generalData.rows !== "undefined" &&
      typeof this.props.generalData.rows.data !== "undefined"
        ? this.props.generalData.rows.data
        : [];

    let columns = this.renderColumns();
    return (
      <BootstrapTable
        remote={{ pagination: true }}
        bootstrap4
        keyField="id"
        data={vehicle_data}
        columns={columns}
        bordered={false}
        rowClasses={"table-row"}
        defaultSorted={this.state.sort}
        pagination={paginationFactory(options)}
        onTableChange={this.handleTableChange}
        noDataIndication={() =>
          this.props.generalData.loading ? <NoDataIndication /> : NO_DATA
        }
      />
    );
  }
}

VehicleGeneralNoteScreen.propTypes = {};
VehicleGeneralNoteScreen.defaultProps = {
  historyRef: "",
};

const mapStateToProps = (state) => ({
  generalData: state.VNote.generalData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

// We normally do both in one step, like this:
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VehicleGeneralNoteScreen);
